import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const workforceNotificationsPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-workforce-notifications',
	path: '/jira/settings/personal/workforce-notifications',
};
